/* hl-v11.js · Design-Review 29.09.2026 · nur Format, keine Texte. */
(function () {
  'use strict';
  var doc = document;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (doc.readyState !== 'loading') fn(); else doc.addEventListener('DOMContentLoaded', fn);
  }

  /* hl-v11.css ans Ende von <head>, damit es nach hl-v10.css greift */
  (function moveCss() {
    var link = doc.querySelector('link[href*="hl-v11.css"]');
    if (link && link.parentNode === doc.head) doc.head.appendChild(link);
  })();

  /* G6 · auf Touch-Geraeten haengt kein Hover: :hover-Regeln ausserhalb von
     (hover:hover) werden dort entfernt. Computer mit Maus unveraendert. */
  function dropTouchHover() {
    if (!window.matchMedia('(hover: none)').matches) return;
    var sheets = doc.styleSheets;
    for (var i = 0; i < sheets.length; i++) {
      var rules;
      try { rules = sheets[i].cssRules; } catch (e) { continue; }
      if (!rules) continue;
      for (var j = rules.length - 1; j >= 0; j--) {
        var r = rules[j];
        if (r.selectorText && r.selectorText.indexOf(':hover') !== -1) {
          var parts = r.selectorText.split(',');
          var keep = parts.filter(function (p) { return p.indexOf(':hover') === -1; });
          try {
            if (!keep.length) sheets[i].deleteRule(j);
            else r.selectorText = keep.join(',');
          } catch (e) {}
        }
      }
    }
  }

  /* G1 · lange Ueberschriften eine Stufe kleiner */
  function longHeadings() {
    doc.querySelectorAll('.hl-story-panel__heading, .hl-h2').forEach(function (h) {
      if ((h.textContent || '').trim().length > 70) h.classList.add('v11-long');
    });
  }

  /* S3 · Titelblock im Eingang: klar sichtbar oder weg */
  function enterCaption() {
    var cap = doc.querySelector('.hl-enter__caption');
    if (!cap) return;
    var tick = false;
    function upd() {
      tick = false;
      var o = parseFloat(cap.style.opacity);
      if (isNaN(o)) o = 1;
      var gone = o < 0.55;
      cap.classList.toggle('v11-gone', gone);
      cap.classList.toggle('v11-shown', !gone);
    }
    window.addEventListener('scroll', function () {
      if (!tick) { tick = true; requestAnimationFrame(upd); }
    }, { passive: true });
    upd();
  }

  /* P2 · Kaufleiste auch am Computer, sobald der Kaufknopf aus dem Bild ist */
  function stickyBar() {
    var bar = doc.querySelector('[data-hl-sticky-bar]');
    var btn = doc.querySelector('.hl-product__form > .hl-btn--primary');
    if (!bar || !btn) return;
    var foot = doc.querySelector('.hl-footer, footer');
    var tick = false;
    function upd() {
      tick = false;
      var gone = btn.getBoundingClientRect().bottom < 0;
      var footIn = foot ? foot.getBoundingClientRect().top < window.innerHeight : false;
      bar.classList.toggle('is-visible', gone && !footIn);
    }
    window.addEventListener('scroll', function () {
      if (!tick) { tick = true; requestAnimationFrame(upd); }
    }, { passive: true });
    window.addEventListener('resize', upd, { passive: true });
    upd();
  }

  /* P6 · Amazon-Hinweis ans Ende der Seite, vor die Fusszeile */
  function moveAmazon() {
    var box = doc.querySelector('.hl-product__amazon');
    var main = doc.querySelector('main');
    if (!box || !main) return;
    var wrap = doc.createElement('div');
    wrap.className = 'hl v11-amazon-end';
    wrap.style.cssText = 'max-width:var(--hl-page-width,1320px);margin:0 auto;padding:0 var(--hl-gutter,24px) 48px';
    box.classList.add('v11-moved');
    wrap.appendChild(box);
    main.appendChild(wrap);
  }

  /* SP1 · Galerie mit nur einem Bild ohne Vorschauleiste */
  function singleGallery() {
    doc.querySelectorAll('.hl-gallery').forEach(function (g) {
      var n = Array.prototype.filter.call(g.querySelectorAll('.hl-gallery__thumb'), function (b) {
        return b.getClientRects().length && getComputedStyle(b).display !== 'none' && !b.hidden;
      }).length;
      if (n <= 1) g.setAttribute('data-v11-single', '');
    });
  }

  /* U1 · Fortschrittslinie im Flur (ohne Text) */
  function flurProgress() {
    var walk = doc.querySelector('.hl-flur__walk');
    if (!walk || reduced) return;
    var bar = doc.createElement('div');
    bar.className = 'v11-progress';
    bar.setAttribute('aria-hidden', 'true');
    doc.body.appendChild(bar);
    var tick = false;
    function upd() {
      tick = false;
      var r = walk.getBoundingClientRect();
      var total = walk.offsetHeight - window.innerHeight;
      var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
      bar.style.setProperty('--v11-p', p.toFixed(4));
      bar.classList.toggle('is-on', r.top < 0 && r.bottom > window.innerHeight * 0.6);
    }
    window.addEventListener('scroll', function () {
      if (!tick) { tick = true; requestAnimationFrame(upd); }
    }, { passive: true });
    window.addEventListener('resize', upd, { passive: true });
    upd();
  }

  /* M3 · nummerierte Schritte zeilenweise (gleicher Text, nur Umbruch) */
  function steps() {
    doc.querySelectorAll('.hl-assembly__text').forEach(function (p) {
      if (p.children.length) return;
      var t = p.textContent;
      if (!/(^|\s)1\.\s/.test(t) || !/\s2\.\s/.test(t)) return;
      var parts = t.split(/\s(?=\d{1,2}\.\s)/);
      if (parts.length < 2) return;
      p.textContent = '';
      p.classList.add('v11-steps');
      parts.forEach(function (s, i) {
        var span = doc.createElement('span');
        span.textContent = (i ? ' ' : '') + s;
        p.appendChild(span);
      });
    });
  }

  /* SU1 · Suchergebnisse mit der Kollektionskarte */
  function searchCards() {
    if (!doc.querySelector('.hl-section-search, .hl-search-form')) return;
    doc.querySelectorAll('.hl-room__grid .hl-card').forEach(function (c) { c.classList.add('hl-card--lb'); });
  }

  /* Kontakt: E-Mail-Weg support@ hervorheben (nur Darstellung, Reihenfolge per CSS) */
  function contactPrimary() {
    doc.querySelectorAll('.hl-contact__channel').forEach(function (c) {
      if (/support@/i.test(c.textContent)) c.classList.add('v11-primary');
      else if (/whatsapp/i.test(c.textContent)) c.style.order = '1';
    });
  }

  /* Kopfbilder oben auf der Seite (Wasche, Bad, Kueche): das feste Bild endet
     an der Unterkante des Bandes, damit das ganze Motiv sichtbar ist */
  function bandFocalBottom() {
    var bands = doc.querySelectorAll('.hl-band[data-parallax="true"]');
    function fit() {
      bands.forEach(function (b) {
        var fix = b.querySelector('.hl-band__fix');
        var media = b.querySelector('.hl-band__media');
        if (!fix || !media) return;
        var wide = window.matchMedia('(min-width: 750px)').matches;
        var top = b.getBoundingClientRect().top + window.pageYOffset;
        if (!wide || top > window.innerHeight * 0.5) {
          fix.style.height = ''; media.style.height = ''; media.style.marginTop = ''; return;
        }
        /* Bild genau im Band, nicht hinter der Kopfzeile: ganzes Motiv sichtbar */
        fix.style.height = Math.round(top + b.offsetHeight) + 'px';
        media.style.marginTop = Math.round(top) + 'px';
        media.style.height = b.offsetHeight + 'px';
      });
    }
    if (!bands.length) return;
    fit();
    window.addEventListener('resize', fit, { passive: true });
    window.addEventListener('load', fit);
  }

  ready(function () {
    contactPrimary();
    bandFocalBottom();
    dropTouchHover();
    longHeadings();
    enterCaption();
    stickyBar();
    moveAmazon();
    singleGallery();
    flurProgress();
    steps();
    searchCards();
  });
})();
